import { $http } from '../js/http.js'

export default {
  async reset(context) {
    context.commit('RESET')
  },

  async getPerm(context, type = 0) {
    if (context.state.settings.menus.length === 0 || type) {
      // let response = {
      //   a: {
      //     p: {
      //       id: 18033,
      //       company: 'yy test 0815',
      //       uid: 18033,
      //       un: '123fefews@gmail.com',
      //       customer_type: 13,
      //       is_sdk: false,
      //       sdk_agreement_conformed: false,
      //       status: 0,
      //       info: true,
      //       invoice: 1,
      //       perms: [],
      //     },
      //     ct: 600000,
      //     m: {
      //       lang: 'en',
      //       en: [
      //         'view_account',
      //         'view_snapshot',
      //         'view_payment',
      //         'view_channel',
      //         'view_support',
      //         'view_help_report_api',
      //         'view_personal_info'
      //       ],
      //     },
      //     a: 3,
      //   },
      // }
      // 恢复原状
     
      let response = await $http.get('/accounts/profile-r/', {
        params: {
          orgtype: location.host === 'adv-offers.youmi.net' ? 2 : undefined,
        },
      })
      if (context.state.channel.integration === 6) {
        let permArr = ['view_snapshot', 'view_account', 'view_payment','view_help_report_api', 'view_personal_info']
        response.a.m.en = response.a.m.en.filter(item => permArr.includes(item))
      }
      context.commit('SETTINGS', response)
      // 给ticketbox传参
      window.ticketConfig.id = response.a.p.uid
      window.ticketConfig.email = response.a.p.un
    }
  },

  async getChannelList(context) {
    // TODO avoid magic number
    if (
      context.state.settings.usertype === 3 &&
      (context.state.channel_list.length === 0 || window.location.pathname === '/channel')
    ) {
      // 恢复原状
      // let response = {
      //   "data": [
      //       {
      //           "id": "1601101",
      //           "name": "MATRIX-ID-SpinGo",
      //           "event_postback": "",
      //           "api_key": "0ed0fb2cc82cef187c90fb83d9c6c5fe",
      //           "traffic_type": 13,
      //           "integration": 6,
      //           "domain": "track.adxmel.com",
      //           "postback": ""
      //       }
      //   ]
      // }
      let response = await $http.get('/api/aff/channel/', {
        params: { status: 1 },
      })

      if(context.state.settings.user.customer_type === 13){
        response.data.unshift({
          id: 0,
          name:'All Channel',
          traffic_type: 13,
          integration: 6,
        })
      }

      context.commit('CHANNEL_LIST', response.data)
    }
  },

  async getTimezone(context) {
    if (context.state.timezone.length === 0) {
      let data = await $http.get('/api/common/get-tz-list-r/')
      let tzs = data.tzs
      for (var i = 0; i < tzs.length; i++) {
        tzs[i].name = tzs[i].gmt + ' ' + tzs[i].location
      }
      context.commit('TIMEZONE', tzs)
    }
  },

  async getCountry(context) {
    if (context.state.timezone.length === 0) {
      let data = await $http.get('/api/common/get-countries-r/')
      context.commit('COUNTRY', data.list)
    }
  },

  async getOfferSetting(context) {
    if (Object.keys(context.state.offer_setting).length === 0) {
      let data = await $http.get('/api/common/get-offer-r/')
      context.commit('OFFER_SETTING', data)
    }
  },
}
